module.exports = __webpack_public_path__ + "static/img/img-icon.20253be.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/img-icon.png
// module id = /TA5
// module chunks = 1